import { useState, useEffect, useContext } from 'react';
import { HttpContext } from '../../api-services/HttpService';
import LightPersonIcon from '../../svgs/light-person-icon.svg';
import DarkPersonIcon from '../../svgs/dark-person-icon.svg';
import WarningIcon from '../../svgs/warning-icon.svg';
import displayDateTime from '../functions/displayDateTime';
import '../../css/offcanvasStyle.css';

const ClientProfileWorkflowCommentLog = ({ workflowid, disableHeight = false }) => {
    const { GET } = useContext(HttpContext);
    const [commentList, setCommentList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const getComments = (workflowid) => {
        return new Promise((resolve, reject) => {
            GET('/client/clientProfileWorkflow/comments', { workflowid: workflowid }).then(res => {
                setCommentList(res.data.CommentLog);
                resolve(res);
            }).catch(err => {
                reject(err);
            }).finally(() => setIsLoading(false));
        });
    };

    useEffect(() => {
        getComments(workflowid).then(res => {
            console.log(res);
        }).catch(err => {
            console.log(err);
        });
    }, [workflowid]);

    const formatDate = (date) => {
        const now = new Date();
        const diffMs = now - new Date(date);
        const diffSeconds = diffMs / 1000;
        if (diffSeconds <= 86400) {
            if (diffSeconds < 60) {
                const secs = Math.floor(diffSeconds);
                return `${secs} second${secs !== 1 ? 's' : ''}`;
            } else if (diffSeconds < 3600) {
                const mins = Math.floor(diffSeconds / 60);
                return `${mins} minute${mins !== 1 ? 's' : ''}`;
            } else {
                const hours = Math.floor(diffSeconds / 3600);
                return `${hours} hour${hours !== 1 ? 's' : ''}`;
            }
        } else {
            return displayDateTime(date);
        }
    };

    return (
        <div>
            <div className="offcanvas-details p-3" style={{ fontSize: '12px', borderBottom: '1px solid #ECECEC' }}>
                Comment Log ({commentList.length})
            </div>
            <div style={{ overflowY: 'auto', height: disableHeight ? '' : 'calc(100vh - 320px)' }}>
                {commentList.length > 0 ? commentList.map((el, idx) =>
                    <div key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#F7F9FA' : '#FFFFFE', border: '0.05rem solid #E6EDF1', minHeight: '64px', padding: '8px 0px', fontSize: '12px' }}>
                        <div className="d-flex align-items-center p-1">
                            <img src={idx % 2 === 0 ? LightPersonIcon : DarkPersonIcon} className='ms-2 align-self-baseline' alt="person" />
                            <div className='ps-2'>
                                <span style={{ fontFamily: 'Roboto medium' }}>{el['userid']}</span>
                                <span className='ms-2' style={{ color: '#BDBDBD', fontSize: '11px' }}>{el['commenttype']}</span>
                                <span className='ms-3' style={{ color: '#BDBDBD' }}>{formatDate(el['commenttimestamp'])}</span>
                                <div className="text-break" style={{ color: '#3D3D3D' }}>{el['commenttext']}</div>
                            </div>
                        </div>
                    </div>
                ) : (isLoading ? null :
                    <div className="d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                        <div className={disableHeight ? 'p-3' : ''}>
                            <div className="d-flex justify-content-center">
                                <img src={WarningIcon} alt="warning" />
                            </div>
                            <div>No comments found.</div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ClientProfileWorkflowCommentLog;
